import { render, staticRenderFns } from "./PdfTemplateSettings.vue?vue&type=template&id=04fef238"
import script from "./PdfTemplateSettings.vue?vue&type=script&lang=js"
export * from "./PdfTemplateSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports